export const ROUTE_CODES = {
  DASHBOARD: 'DASHBOARD',
  POS_SETUP: 'SETUP',
  SETUP_UOM: 'UOM_CRUD',
  SETUP_PRODUCT: 'PRODUCT_CURD',
  SETUP_CATEGORY: 'CATEGORY_CRUD',
  SETUP_SUB_CATEGORY: 'SUB_CATEGORY_CRUD',
  SETUP_MASTER_DATA: 'MASTER_DATA_CRUD',
  SETUP_VENDOR: 'VENDOR_CRUD',
  SETUP_WAREHOUSE: 'WAREHOUSE_CRUD',
  SETUP_CUSTOMER: 'CUSTOMER_CRUD',
  SETUP_SUPPLIER: 'SUPPLIER_CRUD',
  SETUP_APPROVAL_WORKFLOW: 'APPROVAL_WORKFLOW_CRUD',
  // The SAVE is gated on this; every code field reads the format ungated. See sql/item_code_config.sql.
  SETUP_ITEM_CODE_CONFIG: 'ITEM_CODE_CONFIG',
  APPROVALS: 'APPROVALS',
  MY_REQUESTS: 'MY_REQUESTS',
  PENDING_APPROVALS: 'PENDING_APPROVALS',
  INVENTORY: 'INVENTORY',
  // Inventory's screens are individually gated. They used to carry no route_code at all, which in
  // renderSubMenu means "always render" -- so the group was all-or-nothing.
  INV_INTERNAL_REQUISITION: 'INV_INT_REQUISITION',
  INV_REQUISITION_ISSUE: 'INV_REQ_ISSUE',
  INV_TRANSFER: 'INV_TRANSFER',
  INV_RECEIVE: 'INV_RECEIVE',
  INV_STOCKS: 'INV_STOCKS',
  INV_STOCK_ADJUSTMENT: 'INV_STOCK_ADJUSTMENT',
  // Must equal auth.features.code exactly -- this app gates on code === routeCode, not on
  // features.url, and a MISSING route_code means ALWAYS ALLOW in both the menu and PrivateRoutes.
  INV_DAMAGE: 'INV_DAMAGE',
  INV_GATE_PASS: 'INV_GATE_PASS',
  POS: 'POS',
  // REPORTS now gates on the GROUP row, like every other top-level menu. It used to point at a
  // POS_REPORTS feature hanging off the module, so the permission tree showed an empty Reports
  // group AND a separate Reports leaf; that leaf is retired and its grants carried onto the group.
  REPORTS: 'REPORTS',
  RPT_INVENTORY: 'RPT_INVENTORY',
  RPT_PURCHASES: 'RPT_PURCHASES',
  // Renamed with the move to Reports (was INV_STOCK_LEDGER). auth.features.code was UPDATED in
  // place, so every existing grant survived -- role_features keys on feature_id, not on the code.
  RPT_STOCK_LEDGER: 'RPT_STOCK_LEDGER',
  RPT_PRODUCT_LEDGER: 'RPT_PRODUCT_LEDGER',
  // Must equal auth.features.code AND store-service's EndpointFeatures "/report/grn" entry, or the
  // console renders the screen while every call it makes answers 403.
  RPT_GRN: 'RPT_GRN',
  // Same contract as RPT_GRN: must equal auth.features.code AND store-service's EndpointFeatures
  // "/report/requisition-tracking" entry.
  RPT_REQ_TRACKING: 'RPT_REQ_TRACKING',
  // Must equal auth.features.code AND the @RequiresPermission(feature = ...) on every
  // /report/spr-detail handler, or the screen renders while every call it makes answers 403.
  RPT_SPR_DETAIL: 'RPT_SPR_DETAIL',
  PROCUREMENT: 'PROCUREMENT',
  // auth.features.code is varchar(26) -- these all fit
  PROCUREMENT_SPR: 'SPR_CRUD',
  PROCUREMENT_CHALLAN: 'CHALLAN_CRUD',
  PROCUREMENT_QC: 'QC_CRUD',
  PROCUREMENT_MRR: 'MRR_CRUD',
  // These four already had auth.features rows and checkboxes, but their menu items carried no
  // route_code -- so the permissions rendered, invited a decision, and did nothing.
  PROCUREMENT_PO: 'PUR_ORDER_CRUD',
};
